import { cx } from '@linaria/core';

import { SizeIconButtonBase } from '../../ButtonBase/SizeIconButtonBase';
import type { SizeIconButtonBaseProps } from '../../ButtonBase/types';
import { styledButton } from '../styles';

export const ButtonIconSecondary = ({
	className,
	...props
}: SizeIconButtonBaseProps) => {
	return (
		<SizeIconButtonBase className={cx(styledButton, className)} {...props} />
	);
};
